export default __webpack_public_path__ + "9c44a9a.png";